import { Injectable } from '@angular/core';
import { ToastComponent } from '../../components/common/toast/toast.component';
import { ToastType } from '../../components/common/toast/toast.model';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  private toastComponent: ToastComponent | null = null;

  register(component: ToastComponent): void {
    this.toastComponent = component;
  }

  
  success(message: string, duration = 6000): void {
    this.show(message, 'success', duration);
  }
  
  error(message: string, duration = 6000): void {
    this.show(message, 'error', duration);
  }
  
  warning(message: string, duration = 6000): void {
    this.show(message, 'warning', duration);
  }
  
  info(message: string, duration = 6000): void {
    this.show(message, 'info', duration);
  }

  private show(message: string, type: ToastType = 'info', duration = 6000): void {
    this.toastComponent?.show(message, type, duration);
  }
}
